import styled from "styled-components";

let titleBarHeight = 100;

export const TractorOverviewWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    color: #EFEFEF;
    background-color: rgb(5, 12, 38);
`;

export const TractorOverviewInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-image: url("/static/images/big-screen/tractor/overview-screen-background.png");
    background-size: 100% 100%;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 100;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight}px;
    padding: 40px 10px 10px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const OverviewBigScreenContent = styled.div`
    display: grid;
    position: absolute;
    top: calc(${titleBarHeight}px);
    width: 100%;
    height: calc(100% - ${titleBarHeight}px);
    padding: 10px 30px 32px 30px;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-template-columns: minmax(0, 2fr) minmax(0, 5fr) minmax(0, 2fr);
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-gap: 10px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    z-index: 100;
`;

export const DeviceListWrapper = styled.div`
    grid-column: 1 / span 1;
    grid-row: 1 / span 3;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;

export const DeviceMapWrapper = styled.div`
    grid-column: 2 / span 1;
    grid-row: 1 / span 3;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
`;

export const DeviceOnlineStatisticsWrapper = styled.div`
    grid-column: 3 / 4;
    grid-row: 1 / 2;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;

export const DeviceAlarmStatisticsWrapper = styled.div`
    grid-column: 3 / span 1;
    grid-row: 1 / span 1;
    box-sizing: border-box;
    z-index: 100;
`;

export const DeivceOnlineDurationWrapper = styled.div`
    grid-column: 3 / span 1;
    grid-row: 2 / span 1;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
    position: relative;
`;

export const DeviceAnalyseWrapper = styled.div`
    grid-column: 3 / span 1;
    grid-row: 3 / span 1;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;

